<template>
    <div class="nav">
        <router-link
            class="nav-btn"
            :class="{ active: isActive(key) }"
            v-for="(category, key) in $global.categories"
            :key="key"
            :to="{ name: key }"
        >
            {{ category }}
        </router-link>
    </div>
</template>

<script>
export default {
    name: 'Navbar',
    methods: {
        isActive(key) {
            return this.$route.meta.category === key;
        },
    },
};
</script>

<style scoped lang="sass">
.nav
    padding: 16px
    position: fixed
    top: 0
    background: white

.nav-btn
    text-decoration: none
    padding: 16px
    color: black

    &:hover,
    &.active
        background-color: rgba(224, 81, 32, 0.8)
        color: white
</style>
